import { Config, createForm, FormApi, FormState } from 'final-form';
import arrayMutators from 'final-form-arrays';
import setFieldData from 'final-form-set-field-data';
import setFieldTouched from 'final-form-set-field-touched';
import { defineComponent } from 'vue';

export const Form = defineComponent({
    // named so specs can target it via `stubs: { sForm: ... }` (matched by component name)
    name: 'SForm',
    props: ['validate', 'onSubmit', 'initialValues'],
    template: require('./form.html'),
    data() {
        return {
            formState: null as any as FormState<any>,
            form: null as any as FormApi,
            unsubscribe: undefined as (() => void) | undefined,
        }
    },
    created() {
        this.form = createForm({
            initialValues: this.initialValues,
            mutators: { setFieldTouched, setFieldData, ...arrayMutators },
            onSubmit: this.onSubmit,
            validate: this.validate,
        });

        this.unsubscribe = this.form.subscribe(
            state => {
                this.formState = state;
                this.$emit('change', state.values);
            },
            {
                active: true,
                dirty: true,
                dirtySinceLastSubmit: true,
                error: true,
                errors: true,
                hasSubmitErrors: true,
                hasValidationErrors: true,
                initialValues: true,
                invalid: true,
                pristine: true,
                submitError: true,
                submitErrors: true,
                submitFailed: true,
                submitSucceeded: true,
                submitting: true,
                touched: true,
                valid: true,
                validating: true,
                values: true,
                visited: true,
            },
        );
    },
    beforeUnmount() {
        this.unsubscribe?.();
    },
    methods: {
        handleSubmit(event: Event) {
            event.preventDefault();
            this.form.submit();
        },
    },
})
